import { getSessionTokenOrRedirect } from '@bundles/libs/shopify/appBridge'
import { useAuthStore } from '@bundles/store/authStore'
import { getShopifyParams } from '@utils/getShopifyParams'
import {
  isShopifyAuthFailure,
} from '@utils/shopifyAuthFailure'
import { useEffect, useRef } from 'react'

const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL

export const useShopifyToken = () => {
  const { token, setToken, setHostAndShop, setIsLoading, isHydrated } =
    useAuthStore()
  const { host, shop } = getShopifyParams()

  const authProcessedRef = useRef(false)
  const tokenFetchingRef = useRef(false)

  useEffect(() => {
    if (!isHydrated) {
      return
    }

    if (authProcessedRef.current) {
      return
    }

    if (!shop || !host) {
      setIsLoading(false)
      return
    }

    setHostAndShop(host, shop)
    const isEmbedded = window.top !== window.self

    if (!isEmbedded) {
      authProcessedRef.current = true
      setIsLoading(false)
      return
    }

    const fetchToken = async () => {
      if (tokenFetchingRef.current) {
        return
      }

      tokenFetchingRef.current = true

      try {
        const sessionToken = await getSessionTokenOrRedirect()
        if (sessionToken) {
          setToken(sessionToken)
        }
        authProcessedRef.current = true
      } catch (err) {
        authProcessedRef.current = true
        if (!isShopifyAuthFailure(err) && BACKEND_BASE_URL) {
          window.location.href = `${BACKEND_BASE_URL}/login?shop=${shop}&top_level=true`
        }
      } finally {
        tokenFetchingRef.current = false
        setIsLoading(false)
      }
    }

    if (token) {
      authProcessedRef.current = true
      setIsLoading(false)
    } else {
      setIsLoading(true)
      fetchToken()
    }
  }, [token, shop, host, setToken, setHostAndShop, setIsLoading, isHydrated])
}
